import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormControl  } from '@angular/forms';
@Component({
  selector: 'app-filter-box',
  templateUrl: './filter-box.component.html',
  styleUrls: ['./filter-box.component.css']
})
export class FilterBoxComponent implements OnInit {
  
  @Input() filterActive: boolean = false;
  @Input() formFilter: FormGroup;
  @Output() cleanSearch = new EventEmitter<void>();
  @Output() closeFilter = new EventEmitter<void>();
  @Output() search = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }
  onCleanSearch(){
    this.cleanSearch.emit();    
  }
  onCloseFilter(){
    this.closeFilter.emit();    
  }
  onSearch(){
    this.search.emit();    
  }
}
